import { defaultDeckColorTags } from 'app-redux/deck/initialState'

import { GlobalColorTag } from 'services/apiTypes/colorTag.types'

type TagReducerType = {
  defaultColorTags: GlobalColorTag[]
  userColorTags: GlobalColorTag[]
}

type SortedTagsType = {
  defaultColorTags: GlobalColorTag[]
  userColorTagsSorted: GlobalColorTag[]
  nonEditableTags: Record<string, boolean>
  generateLookupKey: (tag: GlobalColorTag) => string
}

export const sortColorTags = (tags: GlobalColorTag[]): SortedTagsType => {
  const generateLookupKey = (tag: GlobalColorTag) => `${tag.name},${tag.color}`
  const nonEditableTags: Record<string, boolean> = defaultDeckColorTags.reduce(
    (acc, tag) => ({ ...acc, [generateLookupKey(tag)]: true }),
    {},
  )

  const { defaultColorTags, userColorTags } = tags.reduce(
    (acc, tag) => {
      if (nonEditableTags[generateLookupKey(tag)]) return { ...acc, defaultColorTags: [...acc.defaultColorTags, tag] }

      return { ...acc, userColorTags: [...acc.userColorTags, tag] }
    },
    { defaultColorTags: [], userColorTags: [] } as TagReducerType,
  )

  const userColorTagsSorted = sortColorTagList(userColorTags)

  return { defaultColorTags, userColorTagsSorted, nonEditableTags, generateLookupKey }
}

export const sortColorTagList = (tags: GlobalColorTag[]): GlobalColorTag[] => {
  const alphaNumericCollator = new Intl.Collator(undefined, { numeric: true, sensitivity: 'base' })

  return tags.sort((tagA, tagB) => alphaNumericCollator.compare(tagA.name, tagB.name))
}
